export enum LayerFilterQueryConditional {
  and = "AND",
  or = "OR",
}
